import { useState } from "react";
import { ITurnoListRequest } from "../../../../../Interfaces/auxiliar/ITurno";
import { IPanelTurnoFiltro } from "./PanelTurnoFiltro";

export const UsePanelTurnoFiltro=(props:IPanelTurnoFiltro)=>{
    // const [filter, setFilter] = useState<ITurnoListRequest>({
    //    skip:0,take:50
    // });
    const cerrarPanel = () => {
        // setFilter({skip:0,take:50})
        props.onDismiss()
    };
    const filtrar=()=>{
        const { skip, take } = props.filtro;
        const {horaFin,horaInicio,nombre,codigo} =props.filtro
        const filterMax: ITurnoListRequest = {
            skip,
            take,
            horaFin: horaFin??undefined,
            horaInicio: horaInicio??undefined,
            nombre: nombre??undefined,
            codigo:codigo??undefined
        }
        props.reload()
        props.setFiltro(filterMax)
        cerrarPanel()
    }
    return {filtrar,cerrarPanel}
}